import { useUserDataContext } from "contexts/UserDataContext/UserDataContext";
import { IQ_BULK_CSV_UPLOAD } from "types/teamFeatureFlagType";

export const useIsBulkScenarioUploadEnabled = (): boolean => {
    const { teamFeatureFlags } = useUserDataContext();
    return teamFeatureFlags.includes(IQ_BULK_CSV_UPLOAD);
};
